




















































































































































import { Component, Prop } from 'vue-property-decorator';
import {
  MoreVerticalIcon,
  PaperclipIcon,
  MassageSquareIcon,
  CalendarIcon,
} from 'vue-feather-icons';
import Avatar from '@/components/common/Avatar.vue';
import KanbanBoard from '@/components/common/KanbanBoard.vue';
import KanbanItem from '@/components/common/KanbanItem.vue';
import { DamageStatus, IDamage } from 'admiral-core';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import draggable from 'vuedraggable';
import { DamageApi } from '@/services/DamageApi';

@Component({
  components: {
    Avatar,
    MoreVerticalIcon,
    PaperclipIcon,
    MassageSquareIcon,
    CalendarIcon,
    KanbanBoard,
    KanbanItem,
    draggable,
  },
})
export default class DamageKanban extends mixins(BaseMixin) {
  @Prop({ required: true, type: Array })
  damages!: IDamage[];

  damageStatus = DamageStatus;

  onReload() {
    this.$emit('reload');
  }

  // DamageKanban.vue.ts
  get groupedDamages(): Partial<Record<DamageStatus, IDamage[]>> {
    const groups: Partial<Record<DamageStatus, IDamage[]>> = {
      [DamageStatus.NEW]: [],
      [DamageStatus.IN_PROGRESS]: [],
      [DamageStatus.PENDING]: [],
      [DamageStatus.SUBMITTED]: [],
      [DamageStatus.COMPLETED]: [],
      [DamageStatus.DECLINED]: [],
      [DamageStatus.DELETED]: [],
    };
    for (const d of this.damages) {
      if (groups[d.status]) {
        groups[d.status]!.push(d);
      }
    }
    for (const arr of Object.values(groups)) {
      if (arr) arr.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    }
    return groups;
  }

  async onDragEnd(evt: any) {
    if (evt.oldDraggableIndex === evt.newDraggableIndex && evt.from === evt.to) return;

    const movedId = (evt.item as HTMLElement).dataset.damageId!;
    const moved = this.damages.find((d) => d.id === movedId)!;
    const newStatus = (evt.to as HTMLElement).dataset.status as DamageStatus;
    const newIndex = evt.newDraggableIndex; // Ziel-Index (0-basiert)

    /* 1) Liste ohne die gezogene Karte -------------------------------- */
    const listFull = this.groupedDamages[newStatus];
    if (!listFull) return;
    const list = listFull.filter((d) => d.id !== movedId);

    /* 2) Nachbarn herausfinden ---------------------------------------- */
    const prev = list[newIndex - 1]?.order; // undefined falls am Anfang
    const next = list[newIndex]?.order; // undefined falls am Ende

    let newOrder: number;
    if (!prev && !next) newOrder = 1;
    // einzige Karte
    else if (!prev) newOrder = next! / 2;
    // ganz vorne
    else if (!next) newOrder = prev + 1;
    // ganz hinten
    else newOrder = (prev + next) / 2; // dazwischen

    /* 3) Optimistisch setzen ------------------------------------------ */
    this.$set(moved, 'status', newStatus);
    this.$set(moved, 'order', newOrder);

    await this.$nextTick(); // DOM einmal neu rendern

    /* 4) Backend nur mit Index informieren ---------------------------- */
    try {
      const res = await DamageApi.move(moved.id, { status: newStatus, order: newIndex });
      this.$set(moved, 'order', res.data.order); // exakt übernehmen
    } catch (e) {
      this.$toastr.e('Verschieben fehlgeschlagen');
      this.$emit('reload');
    }
  }

  openEditDamageModal(damage: IDamage) {
    this.$emit('open-damage', damage.id);
  }

  updatedDamage(damage: IDamage) {
    this.$emit('update-damage', damage);
  }
}
